import { COLOR, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";
import { Z_INDEX } from "~/styles/z-index";

export const DivContainer = styled.div`
  position: fixed;
  top: ${GLOBAL_NAVI_HEIGHT.PC}px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${Z_INDEX.HEADER};
  background-color: ${COLOR.GRAY100.code};
`;

export const DivWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  gap: 16px;
  padding: 32px;
  max-width: 1024px;
`;

export const ButtonMainItem = styled.button<{
  variant?: "primary" | "secondary";
}>`
  width: 228px;
  height: 80px;
  border-radius: 8px;
  text-align: center;
  white-space: pre;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLOR.GRAY200.code};
  font-weight: ${FONT_WEIGHT.BOLD};
`;
